export enum ReturnCodeStatus {
  ACTIVE = 'active',
  PASSIVE = 'passive',
}
